"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedExperimentArray = exports._formatSingleExperimentTreatment = void 0;

var _formatSingleExperimentTreatment = function _formatSingleExperimentTreatment(treatment) {
  var isAssigned = treatment.parameters.some(function (param) {
    return param.isAssigned;
  });

  if (!isAssigned) {
    return null;
  }

  var paramsString = treatment.parameters.map(function (param) {
    return "(" + param.key + ":" + param.value + ")";
  }).join('');
  return treatment.key + "|" + paramsString;
};

exports._formatSingleExperimentTreatment = _formatSingleExperimentTreatment;

var getFormattedExperimentArray = function getFormattedExperimentArray(experimentReducerState) {
  if (!experimentReducerState || experimentReducerState.isLoading || experimentReducerState.hasErrors) {
    return [];
  }

  var treatments = experimentReducerState.treatments;
  return treatments.map(_formatSingleExperimentTreatment).filter(function (t) {
    return Boolean(t);
  });
};

exports.getFormattedExperimentArray = getFormattedExperimentArray;